interface Props {
  children?: any;
  style?: React.CSSProperties;
}

export default (props: Props) => {
  return <h3 style={{ margin: 0, ...props.style }}>
    {props.children}
  </h3>
};